module.exports = __webpack_public_path__ + "newprotal/img/unsale1.edd6a260.png";